import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName/index.js';
export const Error = ({ message, className, }) => (_jsx("div", { children: _jsx("p", { className: constructClassName([
            styles.errorMessage,
            className,
        ]), children: message }) }));
